export const extractShErrorMessage = response =>
  response?.response?.data?.error?.message ?? response.message;
